import { render } from "./HomeForWho.vue?vue&type=template&id=5f23ce2f&scoped=true"
import script from "./HomeForWho.vue?vue&type=script&lang=js"
export * from "./HomeForWho.vue?vue&type=script&lang=js"

import "./HomeForWho.vue?vue&type=style&index=0&id=5f23ce2f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f23ce2f"]])

export default __exports__